export const peuple = [
    {
        id: 1,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Police"
    },
    {
        id: 2,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Sociologue"
    },
    {
        id: 3,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Ingenieur Btp"
    },
    {
        id: 4,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 5,
        nom: "Alpha",
        prenom: "romeo",
        telephone: "034 00 000 00",
        cin : "120 872 158 214",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Gendarme"
    },
    {
        id: 6,
        nom: "ALson",
        prenom: "David",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "alson@gmail.com",
        adresse: "lot bis ambohijanahary",
        sexe: "homme",
        Profession: "Mecanicien"
    },
    {
        id: 8,
        nom: "Alian",
        prenom: "antonio",
        telephone: "034 00 000 00",
        cin : "170 852 126 780",
        email: "alian@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Pilote"
    },
    {
        id: 9,
        nom: "Fanamby",
        prenom: "Steve",
        telephone: "034 00 757 00",
        cin : "120 852 126 254",
        email: "fanamby@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 10,
        nom: "Fetra",
        prenom: "jezz",
        telephone: "034 00 000 00",
        cin : "890 852 126 254",
        email: "fetrajezz@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "chauffeur"
    },
    {
        id: 11,
        nom: "Stephen",
        prenom: "curry",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 12,
        nom: "Nathan",
        prenom: "bezer",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Informaticien"
    },
    {
        id: 13,
        nom: "Fifaliana",
        prenom: "ny avo",
        telephone: "034 00 000 00",
        cin : "756 457 457 254",
        email: "fifialiananyavo@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "teleoperateur"
    },
    {
        id: 14,
        nom: "sitraka",
        prenom: "sitrakaMichaella",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "Vendeur"
    },
    {
        id: 15,
        nom: "manou",
        prenom: "Razafindraibe",
        telephone: "034 00 000 00",
        cin : "145 574 457 486",
        email: "manourazafy@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "directrice Fip"
    },
    {
        id: 1,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Police"
    },
    {
        id: 2,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Sociologue"
    },
    {
        id: 3,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Ingenieur Btp"
    },
    {
        id: 4,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 5,
        nom: "Alpha",
        prenom: "romeo",
        telephone: "034 00 000 00",
        cin : "120 872 158 214",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Gendarme"
    },
    {
        id: 6,
        nom: "ALson",
        prenom: "David",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "alson@gmail.com",
        adresse: "lot bis ambohijanahary",
        sexe: "homme",
        Profession: "Mecanicien"
    },
    {
        id: 8,
        nom: "Alian",
        prenom: "antonio",
        telephone: "034 00 000 00",
        cin : "170 852 126 780",
        email: "alian@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Pilote"
    },
    {
        id: 9,
        nom: "Fanamby",
        prenom: "Steve",
        telephone: "034 00 757 00",
        cin : "120 852 126 254",
        email: "fanamby@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 10,
        nom: "Fetra",
        prenom: "jezz",
        telephone: "034 00 000 00",
        cin : "890 852 126 254",
        email: "fetrajezz@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "chauffeur"
    },
    {
        id: 11,
        nom: "Stephen",
        prenom: "curry",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 12,
        nom: "Nathan",
        prenom: "bezer",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Informaticien"
    },
    {
        id: 13,
        nom: "Fifaliana",
        prenom: "ny avo",
        telephone: "034 00 000 00",
        cin : "756 457 457 254",
        email: "fifialiananyavo@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "teleoperateur"
    },
    {
        id: 14,
        nom: "sitraka",
        prenom: "sitrakaMichaella",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "Vendeur"
    },
    {
        id: 15,
        nom: "manou",
        prenom: "Razafindraibe",
        telephone: "034 00 000 00",
        cin : "145 574 457 486",
        email: "manourazafy@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "directrice Fip"
    },
    {
        id: 1,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Police"
    },
    {
        id: 2,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Sociologue"
    },
    {
        id: 3,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Ingenieur Btp"
    },
    {
        id: 4,
        nom: "RAKOTO",
        prenom: "Herizo",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 5,
        nom: "Alpha",
        prenom: "romeo",
        telephone: "034 00 000 00",
        cin : "120 872 158 214",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Gendarme"
    },
    {
        id: 6,
        nom: "ALson",
        prenom: "David",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "alson@gmail.com",
        adresse: "lot bis ambohijanahary",
        sexe: "homme",
        Profession: "Mecanicien"
    },
    {
        id: 8,
        nom: "Alian",
        prenom: "antonio",
        telephone: "034 00 000 00",
        cin : "170 852 126 780",
        email: "alian@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Pilote"
    },
    {
        id: 9,
        nom: "Fanamby",
        prenom: "Steve",
        telephone: "034 00 757 00",
        cin : "120 852 126 254",
        email: "fanamby@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 10,
        nom: "Fetra",
        prenom: "jezz",
        telephone: "034 00 000 00",
        cin : "890 852 126 254",
        email: "fetrajezz@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "chauffeur"
    },
    {
        id: 11,
        nom: "Stephen",
        prenom: "curry",
        telephone: "034 00 000 00",
        cin : "120 852 126 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Etudiant"
    },
    {
        id: 12,
        nom: "Nathan",
        prenom: "bezer",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "homme",
        Profession: "Informaticien"
    },
    {
        id: 13,
        nom: "Fifaliana",
        prenom: "ny avo",
        telephone: "034 00 000 00",
        cin : "756 457 457 254",
        email: "fifialiananyavo@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "teleoperateur"
    },
    {
        id: 14,
        nom: "sitraka",
        prenom: "sitrakaMichaella",
        telephone: "034 00 000 00",
        cin : "125 574 457 254",
        email: "example@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "Vendeur"
    },
    {
        id: 15,
        nom: "manou",
        prenom: "Razafindraibe",
        telephone: "034 00 000 00",
        cin : "145 574 457 486",
        email: "manourazafy@gmail.com",
        adresse: "AZ 60 K III",
        sexe: "femme",
        Profession: "directrice Fip"
    },
]